"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntercomHelp = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUseIntercom = require("react-use-intercom");
const IntercomHelp = props => {
  return /*#__PURE__*/_react.default.createElement(_reactUseIntercom.IntercomProvider, (0, _extends2.default)({}, props, {
    autoBoot: true
  }));
};
exports.IntercomHelp = IntercomHelp;
IntercomHelp.propTypes = {
  /** The app_id of your Intercom app which will indicate where to store any data. */
  appId: _propTypes.default.string.isRequired,
  /** The user_id address of the currently logged in user. */
  user_id: _propTypes.default.string,
  /** The email address of the currently logged in user. */
  email: _propTypes.default.string,
  /** Name of the current user/lead */
  name: _propTypes.default.string,
  /** Dictate the alignment of the default launcher icon to be on the left/right. */
  alignment: _propTypes.default.oneOf(['left', 'right']),
  /** Move the default launcher icon vertically.
   * Minimum value: 20.
   */
  vertical_padding: _propTypes.default.number,
  /** Move the default launcher icon horizontally.
   * Minimum value: 20.
   */
  horizontal_padding: _propTypes.default.number,
  /** Time in milliseconds for the Intercom session to be considered active. */
  session_duration: _propTypes.default.number,
  /** Used behind your team profile and other attributes.
   * The color string can be any valid CSS: "color name", "hex" or "rgb".
   */
  background_color: _propTypes.default.string,
  /** Used in button links and more to highlight and emphasise.
   *
   * The color string can be any valid CSS: "color name", "hex" or "rgb".
   */
  action_color: _propTypes.default.string
};